export const VTO_MAKEUP_BUTTON = 'vto-button-makeup';
export const VTO_FOUNDATION_BUTTON = 'vto-button-foundation';
export const VTO_PERFECT_SHADES_BUTTON = 'vto-button-perfect-shades';
export const VTO_ALL_SHADES_BUTTON = 'vto-button-all-shades';
export const VTO_PAIR_SHADES_BUTTON = 'vto-button-pair-shades';
export const VTO_SHADE_SELECT = 'vto-shade-select';
export const VTO_PRODUCT_PRICE = 'vto-product-price';
export const VTO_PAIR_PRODUCT_LINK = 'vto-pair-product-link';
export const VTO_PRODUCT_NAME = 'vto-product-name';
export const VTO_PRODUCT_SUBHEADER = 'vto-product-subheader';
export const VTO_PRODUCT_SIZE = 'vto-product-size';
export const VTO_PRICE_FORMATTED = 'vto-price-formatted';
export const VTO_SKIN_CARE_RESULT_BUTTON = 'vto-skin-care-result-button';
export const VTO_SKIN_CARE_BUTTON = 'vto-skin-care-button';
export const VTO_CUSTOM_PAIR_SHADE_PICKER = 'vto-custom-shade-pair-picker';
export const VTO_SHADE_SWATCH = 'vto-shade-swatch';
export const VTO_SAVE_MATCHES = 'vto-save-matches';
export const VTO_REMOVE_MATCHES = 'vto-remove-matches';
export const TAX_INCLUDED = 'tax-included';
export const VTO_SKINCARE_PRODUCT_GRID = 'vto-skincare-product-grid';
export const VTO_SKINCARE_PRIORITY_PRODUCT_GRID = 'vto-skincare-priority-product-grid';
export const SUPPORTED_BROWSER_OVERLAY_COPY = 'supported-browser-overlay-copy';
